import { render, staticRenderFns } from "./RadioItem.vue?vue&type=template&id=f813d1aa&scoped=true"
import script from "./RadioItem.vue?vue&type=script&lang=js"
export * from "./RadioItem.vue?vue&type=script&lang=js"
import style0 from "./RadioItem.vue?vue&type=style&index=0&id=f813d1aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f813d1aa",
  null
  
)

export default component.exports